import React from 'react'
import { string, array } from 'prop-types'
import { EventButtonGroup } from '@/component/Primitive/Events'
import createButtonGroup from '../lib/button-group-creator'

const EventButtonGroupWidget = ({ pageData, buttonGroup, ...other }) => {
  return (
    <EventButtonGroup
      buttonGroup={createButtonGroup(pageData, buttonGroup)}
      {...other}
    />
  )
}

EventButtonGroupWidget.propTypes = {
  align: string,
  buttonGroup: array,
  theme: string,
  pageData: array
}

export default EventButtonGroupWidget
